import React, { useState, useEffect } from 'react';
 
import useTable from '../useTable'
import { ActualizarPersona } from './modalActualizarPersona';
import axios from 'axios';

import { Mensaje } from '../mensajes2';
import { Dimmer } from '../spinner';
/* import { ToastsGeneral } from '../toasts'; */
import { Toasts } from '../toasts';

const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CÉDULA', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'NOMBRES', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'APELLIDOS', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
]

function TablaPersonas() {
    const [titulo, setTitulo] = useState();
    const permiso = JSON.parse(localStorage.getItem('accpersona'))

    const [msg, setMsg] = useState();
    const [titulo1, setTitulo1] = useState();
    const [msg1, setMsg1] = useState();
    const [mostrar5, setMostrar5] = useState(false);
    const [contar, setContar] = useState(0);
    const [contar1, setContar1] = useState(0);
    const [contar2, setContar2] = useState(0);
    const [contar3, setContar3] = useState(0);
    const [contar4, setContar4] = useState(0);
    const [contar5, setContar5] = useState(0);
    const [contarRet, setContarRet] = useState(0);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [usuarioH, setUsuarioH] = useState();
    const [persona, setPersona] = useState();
    const [organizacion, setOrganizacion] = useState();
    const [configCome, setConfigCome] = useState();
    const [usuariow, setUsuariow] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [deuda, setDeuda] = useState();
    const [historico, setHistorico] = useState();
    const [pagow, setPagow] = useState();
    const [retencion, setRetencion] = useState();
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [anioActu, setAnioActu] = useState(localStorage.getItem('anioactu'));
    /*   const accpersonas = JSON.parse(localStorage.getItem('accpersonas')); */

    const [deshabilitado, setDeshabilitado] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.cedula.includes(target.value)
                            || x.nombres.toUpperCase().includes(target.value.toUpperCase())
                            || x.apellidos.toUpperCase().includes(target.value.toUpperCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setFechaSistema(obj.fechasistema);
        seleccionarPersonas();

    }, []);

    const cerrarModalActualizar = () => {

        setPersona();
        setActivate(false);
        setMostrar5(false);
    }

    const renderizar = () => {
        seleccionarPersonas();
    }

    const seleccionarPersonas = () => {
        setActivate(true);
        let campos = 'cedula, trim(nombres) AS nombres, trim(apellidos) AS apellidos';
        let nomtab = 'persona';
        let orden = 'cedula';
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then((response) => {

            if (response.status == 200) {

                if (response.data.length > 0) {
                    setRecords(response.data);
                    setContar4(contar4 + 1);
                    setActivate(false);
                } else {
                    setRecords([]);
                }
            }

            setActivate(false);

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    };

    const SelectPersona = (cedula) => {

        let campos = "*"
        let nomtab = "persona";
        let nomid = "cedula";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`
        console.log(endpoint)


        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then((response) => {

            if (response.status == 200) {

                if (response.data.cedula >= 0) {
                    setPersona({ cedula: response.data.cedula, nombres: response.data.nombres, apellidos: response.data.apellidos, correoe: response.data.correoe, tlf1: response.data.tlf1, tlf2: response.data.tlf2, fnacimiento: response.data.fnacimiento, nacionalidad: response.data.nacionalidad, sexo: response.data.sexo, direccion: response.data.direccion });
                    setMostrar5(true);
                } else {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'error al cargar el usuario', icono: 'informacion' });
                    setActivate(false);
                }

            }


        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
            setActivate(false);

        })

    }

    const agregarPersona = () => {

        /*  if(accpersonas.substring(1,2) !== '0'){ */


        /*    } else {
             setToast({... toast ,mostrar:true, titulo:'Notificación', mensaje:'No Posee los Permisos para Realizar esta Acción'})
           }
    */

    };

    const validarActuPersona = () => {
        if (operacion === 4) {
            setMostrar5(false);
            return;
        }
        setMostrar5(false);
        renderizar();
    }




    const gestionarPersona = (id, ope, per) => (event) => {

        event.preventDefault();


        if (per.toString() === '1') {
            setOperacion(ope);
            if (ope === 1) {
                setOperacion(1);
                setPersona();
                setDeshabilitado(false);
                setMostrar5(true);

            } else {

                setDeshabilitado(false);
                setActivate(true);
                SelectPersona(id);

            }
        } else {
            setToast({
                mostrar: true,
                mensaje: ope === 1 ? 'No posee permiso para Registrar' : ope === 2 ? 'No posee permiso para Editar' : ope === 3 ? 'No posee permiso para Eliminar' : 'No posee permiso para Consultar',
                titulo: 'Alerta.'
            })
        }
    };
    const cerrarToast = () => {
        setToast({
            mostrar: false
        })
    }

    return (
        <div className="h-100 w-100 p-0 m-0">


            <div className="container">
                <div className="content">
                    <div className="card px-3 py-2">
                        <div className="col-md-12 row m-0 py-1">
                            <div className="col-md-3">
                                <input type="text" className="form-control search-input form-control-sm rounded-pill" onChange={handleSearch} placeholder="Buscar" />
                            </div>

                            <div className="col-md-1 ml-auto">
                                <button onClick={gestionarPersona('', 1, permiso.toString().substring(1, 2))} className={permiso.toString().substring(1, 2) === '1' ? 'btn btn-sm btn-primary rounded-pill' : 'btn btn-sm btn-secondary rounded-pill'}><i className="fas fa-plus"></i> </button>
                            </div>

                        </div>
                        <div className="col-md-12">
                            <TblContainer >
                                <TblHead />

                                <tbody>
                                    {

                                        records && recordsAfterPagingAndSorting().map((item, index) => (
                                            <tr key={index} style={{ padding: "0" }}>
                                                <td className='align-baseline' style={{ textAlign: "center", width: "50px" }}>{item.cedula}</td>
                                                <td className='align-baseline' style={{ textAlign: "start", width: "250px" }}>{item.nombres}</td>
                                                <td className='align-baseline' style={{ textAlign: "start", width: "250px" }}>{item.apellidos}</td>

                                                <td className='align-baseline' style={{ textAlign: "center", width: '90px' }}>
                                                    <button onClick={gestionarPersona(item.cedula, 4, permiso.toString().substring(0, 1))} className={permiso.toString().substring(0, 1) === '1' ? 'btn btn-sm btn-info rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'} ><i className="fas fa-eye"></i> </button>
                                                    <button onClick={gestionarPersona(item.cedula, 2, permiso.toString().substring(2, 3))} className={permiso.toString().substring(2, 3) === '1' ? 'btn btn-sm btn-warning rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fa fa-edit"></i> </button>
                                                    <button onClick={gestionarPersona(item.cedula, 3, permiso.toString().substring(3, 4))} className={permiso.toString().substring(3, 4) === '1' ? 'btn btn-sm btn-danger rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}><i className="fa fa-trash"></i> </button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>

                            </TblContainer>
                            <TblPagination />

                        </div>
                    </div>
                </div>
            </div>
            {/*   <ToastsGeneral
            show={toast.mostrar}
            titulo={toast.titulo}
            mensaje={toast.mensaje}
            onHideCancela={cerrarToast}
            /> */}
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <ActualizarPersona
                show={mostrar5} titulo={titulo1} mensaje={msg1}
                onHideCancela={cerrarModalActualizar}
                onHideAcepta={validarActuPersona}
                persona={persona}
                deshabilitado={deshabilitado ? deshabilitado : undefined}
                operacion={operacion}
            />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>

            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast}
            />

        </div >

    );

}

export default TablaPersonas;